import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class ForecastsTableRecursiveRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = { expanded: props.expanded };
  }

  toggleExpansion = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render () {
    let rounder = (n) => Math.round(n * 100) / 100;
    let level = this.props.level;
    let sYR = this.props.sevenYearRange;
    let row = this.props.row;
    let rightAfterParent = this.props.siblingIndex == 0;
    let childSpans = [];
    let children = row.children || [];
    let hasChildren = children.length > 0;
    while(level-- > 0) {
      childSpans.push(<span key={"child" + level} className="div-sidebar child">&nbsp;</span>);
    }

    let nextFirstTdSpan;
    let divSidebarClasses = classNames({
      "div-sidebar": true,
      "toggle": hasChildren,
      "below-parent": rightAfterParent,
    });
    let toggleClasses = classNames({
      fa: true,
      "fa-caret-down": this.state.expanded,
      "fa-caret-right": !this.state.expanded
    });
    if (hasChildren) {

      nextFirstTdSpan = <span className={divSidebarClasses}>
        <i className={toggleClasses}></i>
      </span>;
    } else {
      nextFirstTdSpan = <span className={divSidebarClasses}>&nbsp;</span>;
    }

    let sevenYearRangeTds = sYR.map((year) => {
      let val = row[year];
      if (val) {
        val = rounder(val).toLocaleString();
      }
      return <div className="number-wrapper td" key={row.id + "" + year}>{ val }</div>;
    });
    let cagrTd;
    if (row.cagr && !isNaN(rounder(row.cagr))) {
      cagrTd = <div className="number-wrapper td" key={row.id + "" + "cagr"}>{rounder(row.cagr)}%</div>;
    } else {
      cagrTd = <div className="td number-wrapper" key={row.id + "" + "cagr"}>–</div>;
    }

    let trClasses = classNames({
      tr: true,
      "has-children": hasChildren
    });
    let tr = <div onClick={this.toggleExpansion} className={trClasses} key={"wraras" + row.id}>
      <div className="td" key={row.id + "" + "first"}>
        {childSpans}
        {nextFirstTdSpan}

        <div className="div-wrapper">{row.region_country_name}</div>
      </div>

      <div className="td" key={row.id + "" + "category"}>{row.category}</div>
      {sevenYearRangeTds}
      {cagrTd}
    </div>;
    let childTrs = [];
    let childExpanded = children.length < 2;
    if (this.state.expanded) {
      childTrs = children.map((e, i) => (<ForecastsTableRecursiveRow sevenYearRange={sYR} key={e.id} level={this.props.level + 1} row={e} expanded={childExpanded} siblingIndex={i} />));
    }

    return <div className={classNames({levelWrapper: true, emphasize: this.props.emphasize})} key={"asdadas" + row.id}>{[tr].concat(childTrs)}</div>;
  }
}

ForecastsTableRecursiveRow.propTypes = {
  row: PropTypes.object.isRequired,
  level: PropTypes.number.isRequired,
  siblingIndex: PropTypes.number,
  expanded: PropTypes.bool.isRequired,
  digital: PropTypes.bool,
  sevenYearRange: PropTypes.arrayOf(PropTypes.number).isRequired,
  emphasize: PropTypes.bool
};

export default ForecastsTableRecursiveRow;
